module.exports = __webpack_public_path__ + "img/missing-ltk.ed38f3a.svg";